var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwiftLanguageIcon = function SvgSwiftLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    fill: "#16181c",
    rx: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 6.5c3 1.5 5 3.4 6.4 5.9.3-1.4 0-2.9 0-2.9 1.2 1.8 1.8 3.9 1.3 5.9-.6.4-1.4.6-2.2.6-2.7 0-5.1-1.6-6.3-3.8 1.2.9 2.5 1.4 3.8 1.3-1.7-.7-3-1.9-3.8-3.5.6.4 1.3.7 2 .9C7 9.9 5.8 8.3 5 6.5z"
  })));
};
export default SvgSwiftLanguageIcon;